import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Api from 'api';
import { SimpleModal } from 'components/Modal';
import RadioButton from 'components/RadioButton/RadioButton';
import { TopBarRedesigned } from 'components/TopBarRedesigned';
import { CrossButtonBlack } from 'components/Buttons/CrossButton';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import "@sendbird/chat-ai-widget/dist/style.css";
import { exitReact } from 'utils';
import { 
    Container, 
    QuestionTypeContainer,
    KnowledgeBaseButton,
    TitleContainer,
    PopupTitle,
    ModalText,
    SearchHeader,
    OrDivider,
    SearchButton,
    SearchWrapper,
    SearchIconWrapper,
    StyledTextField,
    QueryTypeLabel,
    StyledCardContent,
} from '../../hygienist/ContactSupport/ContactSupport.styles';
import {
    HelpOutline,
    ErrorOutline,
    Search as SearchIcon,
  } from '@mui/icons-material';
import { Card, CardHeader } from '@mui/material';
import MaterialInput from 'components/Inputs/MaterialInput';
import { ChatWidget } from 'components/ChatWidget';


const DOContactSupport: React.FC = () => {
    const history = useHistory();
    const [questionType, setQuestionType] = useState('general');
    const [message, setMessage] = useState('');
    const [isOpenSuccessModal, setOpenSuccessModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');    

    const onInfoLinkClick = (infoLink: string) => {
        // @ts-ignore
        window.Cordova ? cordova.InAppBrowser.open(
                infoLink,
                '_system',
                'location=yes'
            )
            : window.open(
                infoLink,
                '_blank',
                'location=yes'
            )
    }

    const handleSubmit = async () => {
        if (message.length < 5) {
            alert("Enter at least 5 characters to submit");
            return;
        }

        try {
            await Api.contactSupport({
                questionType,
                text: message,
            });
            setMessage('');
            setOpenSuccessModal(true);
        } catch (error) {
            console.error('Error submitting support request:', error);
            alert('An error occurred while submitting your request. Please try again.');
        }
    };

    const onExit = () => {
        history.push('loading')
        exitReact('home')
    }

    const onSuccessModalClose = () => {
        setOpenSuccessModal(false);
        setMessage('');
    }

    return (
        <>
                <ChatWidget />

                <TopBarRedesigned
                    title="Help Center"
                    onBack={onExit}
                />
                <Container> 
                    <Card sx={{ mb: 4, mt: 4 }}>
                        <StyledCardContent sx={{ pt: 3 }}>
                            <SearchHeader>
                            You'll probably find the answer you need by simply searching our extensive Member Support Database:
                        </SearchHeader>
                        
                        <SearchWrapper>
                            <StyledTextField
                                fullWidth
                                placeholder="Enter your search term..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                variant="outlined"
                            />
                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <SearchButton
                                onClick={() => onInfoLinkClick(`https://support.tempstars.com/hc/en-us/search?utf8=%E2%9C%93&query=${encodeURIComponent(searchQuery)}`)}
                            >
                                Search
                            </SearchButton>
                        </SearchWrapper>
                        <OrDivider>
                            <span>OR</span>
                            <KnowledgeBaseButton onClick={() => onInfoLinkClick('https://support.tempstars.com/')}>
                                Access our entire Support Knowledge Base here
                            </KnowledgeBaseButton>
                        </OrDivider>
                    </StyledCardContent>
                </Card>


                <Card>
                    <CardHeader
                        title="Still stuck?"
                        subheader="Send us a note, our Member Support Team will get on it!"
                        titleTypographyProps={{ align: 'center', variant: 'h6', fontWeight: '700' }}
                        subheaderTypographyProps={{ align: 'center', color: 'var(--text-primary)', fontSize: 'var(--font-size-mid)' }}
                    />
                    <StyledCardContent>
                        <QuestionTypeContainer>
                            <QueryTypeLabel>
                                <RadioButton
                                    isActive={questionType === 'general'}
                                    handleClick={() => setQuestionType('general')}
                                    item="I have a general question"
                                />
                                <HelpOutline color="primary" sx={{ mx: 1.5 }} />
                                <span>I have a general question</span>
                            </QueryTypeLabel>
                            <QueryTypeLabel>
                                <RadioButton
                                    isActive={questionType === 'urgent'}
                                    handleClick={() => setQuestionType('urgent')}
                                    item="I have an emergency or urgent problem"
                                />
                                <ErrorOutline color="error" sx={{ mx: 1.5 }} />
                                <span>I have an emergency or urgent problem</span>
                            </QueryTypeLabel>
                        </QuestionTypeContainer>
                        <MaterialInput
                                name='message'
                                rows={4}
                                multiline
                                value={message}
                                onChange={(e: any) => setMessage(e.target.value)}
                                label="Please provide as much information as possible to improve our service. This form gets submitted to our Support Team, so we'll receive your message and get back to you!"
                            />
                        <StyledButton
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            fullWidth
                            className="no-fastclick"
                        >
                            Submit
                        </StyledButton>
                    </StyledCardContent>
                </Card>
                <SimpleModal isOpen={isOpenSuccessModal}>
                    <>
                        <TitleContainer>
                            <PopupTitle>Success!</PopupTitle>
                            <CrossButtonBlack onClick={onSuccessModalClose} />
                        </TitleContainer>
                        <ModalText>
                            Thank you! We received your request and the information you've provided. 
                            For emergency requests, we'll get back to you right away.
                            For general questions, our response time is within 1 business day.
                        </ModalText>
                        <StyledButton
                            variant="contained"
                            size="large"
                            onClick={() => setOpenSuccessModal(false)}
                            className="no-fastclick"
                        >
                            Ok
                        </StyledButton>
                    </>
                </SimpleModal>
            </Container>
            </>
    );
};

export default DOContactSupport;
